import React, { useState } from 'react';
import { signIn, signUp, confirmSignUp, resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import logo from '../assets/logo/Track my day logo.png';

function Login({ onLogin, onTerug, initialScherm = 'login' }) {
  const [scherm, setScherm] = useState(initialScherm); // login | registreer | bevestig | vergeten | reset
  const [gebruikersnaam, setGebruikersnaam] = useState('');
  const [email, setEmail] = useState('');
  const [loginInput, setLoginInput] = useState('');
  const [wachtwoord, setWachtwoord] = useState('');
  const [nieuwWachtwoord, setNieuwWachtwoord] = useState('');
  const [bevestigWachtwoord, setBevestigWachtwoord] = useState('');
  const [code, setCode] = useState('');
  const [fout, setFout] = useState('');
  const [melding, setMelding] = useState('');
  const [laden, setLaden] = useState(false);

  const reset = () => { setFout(''); setMelding(''); };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLaden(true); reset();
    try {
      const { isSignedIn } = await signIn({ username: loginInput, password: wachtwoord, options: { authFlowType: 'USER_SRP_AUTH' } });
      if (!isSignedIn) throw new Error();
      onLogin(loginInput);
    } catch {
      setFout('E-mailadres, gebruikersnaam of wachtwoord onjuist.');
    } finally { setLaden(false); }
  };

  const handleRegistreer = async (e) => {
    e.preventDefault();
    setLaden(true); reset();
    if (wachtwoord.length < 8) { setFout('Wachtwoord moet minimaal 8 tekens bevatten.'); setLaden(false); return; }
    if (wachtwoord !== bevestigWachtwoord) { setFout('Wachtwoorden komen niet overeen.'); setLaden(false); return; }
    try {
      await signUp({
        username: gebruikersnaam,
        password: wachtwoord,
        options: {
          userAttributes: {
            email,
          }
        }
      });
      setScherm('login');
      setMelding('Account aangemaakt! Je kunt nu inloggen.');
    } catch (err) {
      setFout(err.message || 'Registratie mislukt.');
    } finally { setLaden(false); }
  };

  const handleVergeten = async (e) => {
    e.preventDefault();
    setLaden(true); reset();
    try {
      await resetPassword({ username: email });
      setScherm('reset');
      setMelding('Er is een resetcode verstuurd naar je e-mailadres.');
    } catch {
      setFout('E-mailadres niet gevonden.');
    } finally { setLaden(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setLaden(true); reset();
    try {
      await confirmResetPassword({ username: email, confirmationCode: code, newPassword: nieuwWachtwoord });
      setScherm('login');
      setMelding('Wachtwoord gewijzigd! Je kunt nu inloggen.');
    } catch {
      setFout('Ongeldige code of wachtwoord te zwak.');
    } finally { setLaden(false); }
  };

  const titels = {
    login: 'Inloggen',
    registreer: 'Nieuw account',
    bevestig: 'Account bevestigen',
    vergeten: 'Wachtwoord vergeten',
    reset: 'Nieuw wachtwoord instellen',
  };

  const inputClass = "w-full px-4 py-3 rounded-xl border border-white/20 bg-white/10 text-white placeholder-white/40 focus:ring-2 focus:ring-blue-400 focus:border-transparent transition text-sm";

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#172554' }}>
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">
        <div className="flex flex-col items-center space-y-8 w-full max-w-sm">
          {onTerug && (
            <button
              onClick={onTerug}
              className="self-start text-blue-300 hover:text-white text-sm flex items-center gap-1 transition"
            >
              ← Terug
            </button>
          )}

          <img src={logo} alt="Track My Day" className="h-40 w-auto bg-white rounded-2xl px-8 py-4 shadow-xl" />
          <p className="text-blue-200 text-sm font-medium tracking-wide">{titels[scherm]}</p>

          <div className="w-full space-y-4">
            {melding && <p className="text-sm text-green-300 bg-green-900/30 border border-green-500/30 rounded-xl px-3 py-2">{melding}</p>}
            {fout && <p className="text-sm text-red-300 bg-red-900/30 border border-red-500/30 rounded-xl px-3 py-2">{fout}</p>}

            {/* LOGIN */}
            {scherm === 'login' && (
              <form onSubmit={handleLogin} className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-blue-200 mb-1">E-mailadres of gebruikersnaam</label>
                  <input type="text" value={loginInput} onChange={e => { setLoginInput(e.target.value); reset(); }}
                    className={inputClass} autoFocus required />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-blue-200 mb-1">Wachtwoord</label>
                  <input type="password" value={wachtwoord} onChange={e => { setWachtwoord(e.target.value); reset(); }}
                    className={inputClass} required />
                </div>
                <button type="submit" disabled={laden}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-4 px-6 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-60">
                  {laden ? 'Bezig...' : 'Inloggen'}
                </button>
                <div className="flex justify-between text-sm text-blue-300">
                  <button type="button" onClick={() => { setScherm('vergeten'); reset(); }} className="hover:text-white hover:underline transition">Wachtwoord vergeten?</button>
                  <button type="button" onClick={() => { setScherm('registreer'); reset(); }} className="hover:text-white hover:underline transition">Nieuw account</button>
                </div>
              </form>
            )}

            {/* REGISTREER */}
            {scherm === 'registreer' && (
              <form onSubmit={handleRegistreer} className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-blue-200 mb-1">Gebruikersnaam</label>
                  <input type="text" value={gebruikersnaam} onChange={e => { setGebruikersnaam(e.target.value); reset(); }}
                    className={inputClass} autoFocus required />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-blue-200 mb-1">E-mailadres</label>
                  <input type="email" value={email} onChange={e => { setEmail(e.target.value); reset(); }}
                    className={inputClass} required />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-blue-200 mb-1">Wachtwoord</label>
                  <input type="password" value={wachtwoord} onChange={e => { setWachtwoord(e.target.value); reset(); }}
                    className={inputClass} required minLength={8} />
                  {wachtwoord && (() => {
                    const len = wachtwoord.length;
                    const hasUpper = /[A-Z]/.test(wachtwoord);
                    const hasDigit = /[0-9]/.test(wachtwoord);
                    const hasSymbol = /[^A-Za-z0-9]/.test(wachtwoord);
                    const score = (len >= 8 ? 1 : 0) + (hasUpper ? 1 : 0) + (hasDigit ? 1 : 0) + (hasSymbol ? 1 : 0);
                    const levels = [
                      { label: 'Te kort', color: 'bg-red-500', text: 'text-red-400', bars: 1 },
                      { label: 'Zwak', color: 'bg-orange-400', text: 'text-orange-400', bars: 2 },
                      { label: 'Matig', color: 'bg-yellow-400', text: 'text-yellow-400', bars: 3 },
                      { label: 'Sterk', color: 'bg-green-500', text: 'text-green-400', bars: 4 },
                    ];
                    const idx = len < 8 ? 0 : Math.min(score - 1, 3);
                    const lvl = levels[idx];
                    return (
                      <div className="mt-1.5">
                        <div className="flex gap-1 mb-1">
                          {levels.map((_, i) => (
                            <div key={i} className={`h-1 flex-1 rounded-full transition-colors ${i <= idx ? lvl.color : 'bg-white/20'}`} />
                          ))}
                        </div>
                        <p className={`text-xs ${lvl.text}`}>{lvl.label}{len < 8 ? ` — minimaal 8 tekens (${len}/8)` : ''}</p>
                      </div>
                    );
                  })()}
                </div>
                <div>
                  <label className="block text-sm font-semibold text-blue-200 mb-1">Wachtwoord bevestigen</label>
                  <input type="password" value={bevestigWachtwoord} onChange={e => { setBevestigWachtwoord(e.target.value); reset(); }}
                    className={`w-full px-4 py-3 rounded-xl border focus:ring-2 focus:ring-blue-400 focus:border-transparent transition text-sm bg-white/10 text-white placeholder-white/40 ${bevestigWachtwoord && wachtwoord !== bevestigWachtwoord ? 'border-red-400' : 'border-white/20'}`} required />
                  {bevestigWachtwoord && wachtwoord !== bevestigWachtwoord && (
                    <p className="text-xs text-red-400 mt-1">Wachtwoorden komen niet overeen.</p>
                  )}
                </div>
                <button type="submit" disabled={laden}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-4 px-6 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-60">
                  {laden ? 'Bezig...' : 'Account aanmaken'}
                </button>
                <button type="button" onClick={() => { setScherm('login'); reset(); }} className="w-full text-sm text-blue-300 hover:text-white hover:underline transition">Terug naar inloggen</button>
              </form>
            )}

            {/* BEVESTIG */}
            {scherm === 'bevestig' && (
              <div className="space-y-4 text-center">
                <div className="text-5xl">📧</div>
                <p className="text-blue-200 text-sm">Controleer je inbox op <strong className="text-white">{email}</strong> en klik op de activatielink om je account te activeren.</p>
                <button type="button" onClick={() => { setScherm('login'); reset(); }}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-4 px-6 rounded-xl shadow-lg transition transform hover:scale-105">
                  Terug naar inloggen
                </button>
              </div>
            )}

            {/* WACHTWOORD VERGETEN */}
            {scherm === 'vergeten' && (
              <form onSubmit={handleVergeten} className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-blue-200 mb-1">E-mailadres</label>
                  <input type="email" value={email} onChange={e => { setEmail(e.target.value); reset(); }}
                    className={inputClass} autoFocus required />
                </div>
                <button type="submit" disabled={laden}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-4 px-6 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-60">
                  {laden ? 'Bezig...' : 'Resetcode versturen'}
                </button>
                <button type="button" onClick={() => { setScherm('login'); reset(); }} className="w-full text-sm text-blue-300 hover:text-white hover:underline transition">Terug naar inloggen</button>
              </form>
            )}

            {/* RESET WACHTWOORD */}
            {scherm === 'reset' && (
              <form onSubmit={handleReset} className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-blue-200 mb-1">Resetcode</label>
                  <input type="text" value={code} onChange={e => { setCode(e.target.value); reset(); }}
                    className={inputClass} autoFocus required />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-blue-200 mb-1">Nieuw wachtwoord</label>
                  <input type="password" value={nieuwWachtwoord} onChange={e => { setNieuwWachtwoord(e.target.value); reset(); }}
                    className={inputClass} required />
                </div>
                <button type="submit" disabled={laden}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-4 px-6 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-60">
                  {laden ? 'Bezig...' : 'Wachtwoord wijzigen'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center gap-4 pb-3">
        <span className="flex items-center gap-1.5 text-white/50 text-xs">
          <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"/>
          </svg>
          Android
        </span>
        <span className="text-white/30">·</span>
        <span className="flex items-center gap-1.5 text-white/50 text-xs">
          <svg className="w-4 h-4 fill-current" viewBox="0 0 814 1000" aria-hidden="true">
            <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-34.4-147.2-98.3C27.8 762.5 0 673.6 0 589.7 0 429.6 89.4 318.7 169.5 318.7c47.5 0 86.8 33.1 116.5 33.1 28.3 0 73.3-35.1 128.3-35.1 49.8 0 154.8 4.3 214.6 138.9zm-171.5-157.8c26.3-30.7 44.7-73.3 44.7-115.9 0-5.8-.5-11.7-1.5-17.1-42.3 1.5-93.5 28.2-124.3 62.7-23.5 26.3-45.4 68.9-45.4 112.1 0 6.3.8 12.7 1.3 14.7 2.8.5 7.3 1 11.8 1 37.8 0 86-25.3 113.4-57.5z"/>
          </svg>
          iPhone
        </span>
      </div>

      <footer className="py-4 text-center text-xs text-blue-300">
        © 2026 Powered by <a href="https://www.novarockets.nl" target="_blank" rel="noopener noreferrer" className="hover:text-blue-100 underline">Nova Rockets</a>
      </footer>
    </div>
  );
}

export default Login;

